import React, { memo } from "react";
import PropTypes from "prop-types";
import useCollections from "../../query/useCollections";
import { collectionUrl } from "../../util/url";
import { useMounted } from "../../hook/useMounted";
import "./CuratedCollections.css";

const CollectionCard = memo(function CollectionCard({ collection }) {
  return (
    <a href={collectionUrl(collection)} className="CuratedCollections-card">
      <img
        src={collection.resizedSmallImage}
        alt={collection.title}
        className="CuratedCollections-card-image"
      />
      <div className="CuratedCollections-card-overlay">
        <div className="CuratedCollections-card-type">
          {collection.subtitle}
        </div>
        <div className="CuratedCollections-card-title">{collection.title}</div>
      </div>
    </a>
  );
});

CollectionCard.propTypes = {
  collection: PropTypes.object.isRequired,
};

/**
 * 홈화면 에디터 컬렉션 섹션
 */
const CuratedCollections = memo(function CuratedCollections() {
  const mounted = useMounted();
  const { collections, loading } = useCollections(6, { skip: !mounted });

  if (!mounted) return null;

  if (loading && collections.length === 0) return null;

  return (
    <section className="CuratedCollections">
      <div className="CuratedCollections-inner">
        <div className="CuratedCollections-header">
          <div>
            <div className="CuratedCollections-tag">CURATED COLLECTIONS</div>
            <h2 className="CuratedCollections-title">에디터 컬렉션</h2>
          </div>
          <a href="/collections" className="CuratedCollections-link">
            전체보기
          </a>
        </div>
        <div className="CuratedCollections-grid">
          {collections.map((collection) => (
            <CollectionCard
              key={collection.id}
              collection={collection}
            />
          ))}
        </div>
      </div>
    </section>
  );
});

export default CuratedCollections;
